// extracted by mini-css-extract-plugin
export default {"variants":"Variants_variants__TJr3w","variant":"Variants_variant__6N3zl","active":"Variants_active__o4v2P"};